import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import Panel from '@/Components/Panel.vue';
import TableWrapper from '@/Components/TableWrapper.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import InputLabel from '@/Components/InputLabel.vue';
import ButtonRow from '@/Components/ButtonRow.vue';
import Checkbox from '@/Components/Checkbox.vue';
import FormatTime from '@/Components/FormatTime.vue';
import FormatNumber from '@/Components/FormatNumber.vue';
import Pill from '@/Components/Pill.vue';
import AuthenticatedLayout from '@/Layouts/AuthenticatedLayout.vue';
import { Head } from '@inertiajs/vue3';
import tippy from 'tippy.js'; // Fixed: Changed from { tippy } to default import
import 'tippy.js/dist/tippy.css';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import * as Sentry from "@sentry/vue";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas, faQuestionCircle, faFire, faSkull, faCrown, faCheck, faPlusCircle, faEyeSlash, faCircle } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

library.add(fas, fab, faQuestionCircle, faFire, faSkull, faCrown, faCheck, faPlusCircle, faEyeSlash, faCircle);

const appVersion = 'v0.8';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .component('AuthenticatedLayout', AuthenticatedLayout)
            .component('Head', Head)
            .component('Panel', Panel)
            .component('PrimaryButton', PrimaryButton)
            .component('TextInput', TextInput)
            .component('InputLabel', InputLabel)
            .component('ButtonRow', ButtonRow)
            .component('Checkbox', Checkbox)
            .component('TableWrapper', TableWrapper)
            .component('FormatTime', FormatTime)
            .component('FormatNumber', FormatNumber)
            .component('Pill', Pill)
            .component('font-awesome-icon', FontAwesomeIcon)

        // Register Tippy.js globally
        app.config.globalProperties.$tippy = tippy;

        // Register vue3-toastify globally
        app.config.globalProperties.$toast = toast;

        // Register Tippy.js directive globally
        app.directive('tippy', {
            mounted(el, binding) {
                // Store the tippy instance for updates and cleanup
                el._tippy = tippy(el, {
                    content: binding.value,
                    placement: binding.arg || 'top',
                    arrow: true,
                    appendTo: document.body, // Better for positioning
                    // Use modifiers if provided
                    ...binding.modifiers
                });
            },
            updated(el, binding) {
                // Update content if the value changes
                if (el._tippy) {
                    const content = binding.value;
                    el._tippy.setContent(content);

                    // Update placement if arg changes
                    if (binding.arg && binding.arg !== el._tippy.props.placement) {
                        el._tippy.setProps({ placement: binding.arg });
                    }
                }
            },
            beforeUnmount(el) {
                // Clean up tippy instance when element is removed
                if (el._tippy) {
                    el._tippy.destroy();
                    delete el._tippy;
                }
            }
        });

        // Global variable for app version
        app.config.globalProperties.$appVersion = appVersion;

        // Add global function for dynamic Inertia navigation
        app.config.globalProperties.$navigateTo = function(routeName, params) {
            this.$inertia.get(route(routeName, params));
        };

Sentry.init({
    app,
    dsn: "https://0cf0b923f6aed76a2787849e9d31ff23@o446607.ingest.us.sentry.io/4509394528239616",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // integrations: [
    //     Sentry.browserTracingIntegration({ router })
    // ],
    // Tracing
    tracesSampleRate: 0.2, // Capture 20% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/expanz\.io/]
});


        // Mount the app after registering directives and properties
        app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

